import React from 'react';
import { ArrowRight, Activity, Users, Clock, Award } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Home.css';
import heroImage from '../images/home_image.jpg';
import clinicImage from '../images/clinica/camilla.jpeg';

const Home = () => {
    return (
        <div className="home-page">
            {/* Hero Section */}
            <section className="hero" style={{ backgroundImage: `url(${heroImage})` }}>
                <div className="hero-overlay"></div>
                <div className="hero-content">
                    <h1 className="hero-title">
                        Recupera tu movimiento,<br />
                        <span className="highlight">recupera tu vida.</span>
                    </h1>
                    <p className="hero-subtitle">
                        Fisioterapia avanzada y personalizada en Pedrola y Pinseque.
                        Tratamientos expertos para que vuelvas a sentirte bien.
                    </p>
                    <div className="hero-actions">
                        <Link to="/contacto" className="btn-primary-lg">
                            Pedir Cita
                            <ArrowRight size={20} />
                        </Link>
                        <Link to="/tratamientos" className="btn-secondary-lg">
                            Nuestros Servicios
                        </Link>
                    </div>
                </div>
            </section>

            {/* Features Grid */}
            <section className="features-section">
                <div className="container">
                    <div className="features-grid">
                        <div className="feature-card">
                            <div className="feature-icon">
                                <Activity size={32} />
                            </div>
                            <h3>Terapia Manual</h3>
                            <p>Técnicas especializadas para aliviar el dolor y restaurar la movilidad.</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">
                                <Users size={32} />
                            </div>
                            <h3>Atención Personal</h3>
                            <p>Tratamientos a medida, dedicando el tiempo que tu salud merece.</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">
                                <Clock size={32} />
                            </div>
                            <h3>Sin Esperas</h3>
                            <p>Respetamos tu tiempo con una gestión de citas eficiente.</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">
                                <Award size={32} />
                            </div>
                            <h3>Experiencia Profesional</h3>
                            <p>Años de trayectoria respaldados por formación continua y resultados.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Info Section */}
            <section className="info-section">
                <div className="container split-layout">
                    <div className="info-text">
                        <h2>Tu clínica de confianza en Pedrola y Pinseque</h2>
                        <p>
                            En nuestras clínicas combinamos experiencia clínica con un trato cercano.
                            Entendemos que cada paciente es único, por eso diseñamos planes de
                            recuperación a medida.
                        </p>
                        <ul className="info-list">
                            <li>Rehabilitación deportiva</li>
                            <li>Dolor crónico y agudo</li>
                            <li>Fisioterapia traumatológica</li>
                            <li>Punción seca y electroterapia</li>
                        </ul>
                        <Link to="/clinica" className="link-arrow">
                            Conoce más sobre nosotros <ArrowRight size={16} />
                        </Link>
                    </div>
                    <div className="info-image">
                        <img src={clinicImage} alt="Clínica Fisioterapia Pedrola" className="clinic-photo" />
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <div className="container">
                    <div className="cta-box">
                        <h2>¿Listo para empezar tu recuperación?</h2>
                        <p>Llámanos o escríbenos para reservar tu primera sesión.</p>
                        <Link to="/contacto" className="btn-white-lg">
                            Contactar Ahora
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;
